import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-primary-600">
        <i className="ri-film-line text-3xl" />
      </span>
      <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm md:text-base text-foreground-600">
        你访问的页面不存在或已被移除，不妨回到首页继续探索精彩的影视内容。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-search-line" />
          去搜索影片
        </Link>
      </div>
    </div>
  );
}